import { IPropsInputField } from "./fieldPropertiesInterface";
import InputField from "./inputField";

function NumericField({
  model,
  attr,
  value,
  label,
  onChange,
  required,
  autoFocus
}: IPropsInputField) {
  return (
    <InputField
      type='number'
      attr={attr}
      value={value}
      label={label}
      model={model}
      onChange={onChange}
      required={required}
      autoFocus={autoFocus}
    ></InputField>
  );
}

export default NumericField;